<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="careRemind">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            收费项目统计
        </div>
        <div style="padding: 20px;">
            <div>
                <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList' ref="Search">
                    <template slot="monthrange">
                         <el-date-picker
                            v-model="searchForm.month"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="请选择月份">
                        </el-date-picker>
                    </template>
                    <template slot="button">
                        <el-radio-group v-model="chargeType" @change="getList(true)">
                            <el-radio-button :label="0">床位</el-radio-button>
                            <el-radio-button :label="1">护理</el-radio-button>
                            <el-radio-button :label="2">自选配</el-radio-button>
                        </el-radio-group>
                    </template>
                    <template slot="rightButton">
                         <el-button type="success" icon="el-icon-download" @click="download">导出</el-button>
                    </template>
                </Search>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table v-loading="tableload" :data="tableData" show-summary :max-height="th" border style="width: 100%;">
                        <el-table-column prop="monthString" label="月份" min-width="150"></el-table-column>
                        <el-table-column :prop="chargeTypeName[chargeType]" label="费用名称" min-width="150"></el-table-column>
                        <el-table-column :prop="chargeTypeBlance[chargeType]" label="消费金额"  min-width="150"></el-table-column>
                        <el-table-column prop="createTime" :formatter="formatterTime" label="创建日期"  min-width="180"></el-table-column>
                    </el-table>
                </template>
            </div>

        </div>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import {getStaffCode} from "@/utils/auth";
    import Search from "@/components/Search";

    export default {
        name: "Role",
        data(){
            return{
                chargeType:0,
                chargeTypeUrl:['CensusAutomatchPayServiceMonthRoom/Page','CensusAutomatchPayServiceMonthNursing/Page','CensusAutomatchPayServiceMonthFee/Page'],
                chargeTypeName:['roomTypeName','nursingLevelName','institutionFeeName'],
                chargeTypeBlance:['roomTypePrice','nursingLevelPrice','institutionFeePrice'],
                tableload:false,
                dialogFeeChange:false,
                dialogHandChange:false,
                selectInfo:'',
                tableData:[],
                totalItems: 0,
                pageSize:20,
                roomCodeList:[],
                feeTable:[],
                handTable:[],
                currentPage:1,
                roomCode:'00000000-0000-0000-0000-000000000000',
                number:'',
                status:-1,
                th:0,searchData:[],
                searchForm:{
                    month: '',
                },
                options:[]
            }
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight+50;
        },
        components: {
            Search
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val+50;
            },
        },
        methods:{
            init:function(){
                this.searchData=[
                    {span:24,name:'月份',width:210,value:'monthrange',type:'slot'},
                ]
                var nowDate=new Date();
                var dateMonth=new Date(nowDate.getFullYear(),nowDate.getMonth(),0);
                this.searchForm.month=timefilters(dateMonth).slice(0,7)
            },
            download(){
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$axios.get(this.$institutionUrl + 'CensusAutomatchPayServiceMonthFee/ExportChargeItemStatistics', {
                responseType: 'blob',
                params: {
                    timeStr: timeStr,
                    sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                    staffCode: getStaffCode(),
                    month:this.searchForm.month
                }
                }).then(
                    (response) => {
                    loading.close();
                    // this.goodsClassDataShow = !this.goodsClassDataShow;
                    if (response.data.type === 'application/json') {
                        this.$message({type: 'info', message: '暂无数据'});
                    } else {
                        let fileName = '收费项目统计表.xlsx';
                        this.file(response, fileName);
                    }

                    }
                )
            },
            file(response, fileName) {
                let blob = new Blob([response.data]);
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, fileName);
                } else {
                    let elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                }
            },
            getList(isSearch) {
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableload=true
                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),
                }
                Object.assign(data,this.searchForm)
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+this.chargeTypeUrl[this.chargeType],
                    data: data
                }).then( (response)=> {
                    this.tableload = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data;
                        this.totalItems = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    _this.tableload = false;
                    console.log(error);
                });
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            // current_change:function(currentPage){
            //     this.currentPage = currentPage;
            //     this.getList();
            // },
        }
    }
</script>

<style lang="scss" scoped>
    // .BerthPage{
    //     .el-button{
    //         transform: translate(-1px,0);
    //     }
    // }
    .careRemind /deep/ .el-table__body tr.current-row>td {
        background: rgb(102, 177, 255);
        color:#fff;
    }
</style>
